var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDcJugosGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#aeb0b0;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.06,22.44a8.9,8.9,0,0,0-5.89-3.86,8.56,8.56,0,0,0-3.51.23,24.31,24.31,0,0,1-5.31.85c0-.39,0-.76,0-1.13a10.14,10.14,0,0,0,1.1.06,9.73,9.73,0,0,0,9.57-8.28,1,1,0,0,0-.19-.71,1,1,0,0,0-.63-.38,9.55,9.55,0,0,0-1.41-.1,9.74,9.74,0,0,0-8.65,5.37c-.73-5-3-6.94-3.11-7a.94.94,0,0,0-1.32.11,1,1,0,0,0,.1,1.34S30,11.77,29.44,19.69a25,25,0,0,1-6.11-.88,8.55,8.55,0,0,0-3.51-.23,8.86,8.86,0,0,0-5.88,3.86c-2.6,3.66-3.54,9.25-2.5,15,1.59,8.75,7.31,15.35,13.3,15.35A10.13,10.13,0,0,0,26,52.69a8.17,8.17,0,0,0,4-1.88,8.2,8.2,0,0,0,4,1.88,9.58,9.58,0,0,0,1.21.08c6,0,11.71-6.6,13.3-15.35,1-5.73.11-11.32-2.5-15Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcJugosGray);
export default __webpack_public_path__ + "static/media/DC__jugos_gray.cdac29e4cbb576bcf7448c0f2bc986c0.svg";
export { ForwardRef as ReactComponent };